// extracted by mini-css-extract-plugin
export default {"textWhite":"HowToSection_textWhite__ryZHa","textMain":"HowToSection_textMain__tw3Vj","textBold":"HowToSection_textBold__UtqTQ","list":"HowToSection_list__moMWz"};